// extracted by mini-css-extract-plugin
module.exports = {"vertical_separator":"vertical-separator_vertical_separator__uT6g4"};